import React from "react";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import GetImages from "@/components/GetImages";

import style from "./index.module.css";

import { IPharmacyClinicListing } from "@/models/ApiRequestResponse/patient";

import {
  openClinicMapLocation,
  timeInAmPmFormat,
  transformClasses,
} from "@/utils";
import useIsMobile from "@/utils/hooks/useIsMobile";
import useIsTablet from "@/utils/hooks/useIsTablet";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  medicine,
  setMedicineOrderPlacedRequest,
  setSelectedPharmacy,
} from "@/store/slices/patient/medicine";

interface IExtraProps {
  isSelected?: boolean;
  isBackgroundColor?: boolean;
  hasMap?: boolean;
  onSelect?: () => void;
}
type IProps = IPharmacyClinicListing & IExtraProps;
const PharmacyCard: React.FC<IProps> = (props) => {
  const {
    id,
    name,
    address,
    city,
    deliveryEnabled,
    pickupEnabled,
    distance,
    isBackgroundColor = true,
    hasMap = false,
    startTime,
    endTime,
    isSelected = false,
  } = props;

  const { selectedPharmacy } = useAppSelector(medicine);
  const dispatch = useAppDispatch();
  const { isMobile } = useIsMobile();
  const { isTablet } = useIsTablet();

  const pharmacyCardHandler = () => {
    const { onSelect, isSelected, isBackgroundColor, ...selectedPharmacy } =
      props;

    dispatch(
      setMedicineOrderPlacedRequest({
        key: "pharmacyId",
        value: id,
      })
    );
    dispatch(
      setSelectedPharmacy({
        ...selectedPharmacy,
      })
    );
    onSelect?.();
  };

  return (
    <Grid
      item
      sx={(theme) =>
        !(isMobile || isTablet) && isSelected
          ? {
              bgcolor: theme.palette.primary.light,
              border: `1px solid ${theme.palette.primary.main}`,
            }
          : {
              bgcolor: isBackgroundColor ? "white" : "transparent",
            }
      }
      className={transformClasses(style.container)}
      onClick={pharmacyCardHandler}
    >
      <Grid item className={style.nameContainer}>
        <GetImages name="ClinicSmallIcon" width="20" height="20" />
        <Grid item>
          <Typography component={"p"} className={style.name}>
            {name}
          </Typography>
          <Typography component={"p"} className={style.address}>
            {address},{city}
          </Typography>

          <Typography component={"p"} className={style.pharmacyOpenTime}>
            <FormattedMessage id="open_hours" defaultMessage="Open Hours" />:{" "}
            <Typography
              component={"span"}
              className={style.pharmacyOpenClosingTime}
            >
              {timeInAmPmFormat(startTime)} - {timeInAmPmFormat(endTime)}
            </Typography>
          </Typography>
          {hasMap && (
            <Typography component={"p"} className={style.distance}>
              {distance?.toFixed(1)}km
            </Typography>
          )}
          {!hasMap && (
            <Grid item className={style.medicineOrderType}>
              {deliveryEnabled && (
                <Typography component={"p"} className={style.deliverySpacing}>
                  <GetImages
                    name="DoctorNavLocationIcon"
                    width="16"
                    height="12"
                  />
                  Home Delivery
                </Typography>
              )}
              {pickupEnabled && (
                <Typography component={"p"}>
                  <GetImages name="MedicineOrangeIcon" width="16" height="12" />
                  Pickup
                </Typography>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item>
        {!hasMap && (
          <Typography component={"p"} className={style.distance}>
            {distance?.toFixed(1)}km
          </Typography>
        )}
        {hasMap && (
          <Grid
            item
            className={style.mapIconContainer}
            onClick={() =>
              openClinicMapLocation(
                selectedPharmacy?.latitude,
                selectedPharmacy?.longitude
              )
            }
          >
            <GetImages name="DoctorNavLocationIcon" width="16" height="16" />
            <Typography component={"h5"}>Map</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default PharmacyCard;
